import { useQuery } from "@tanstack/react-query";
import { getPatientByPid } from "apis";
import useGetWhoAmI from "../aorta/who-am-i";

const useGetPatientByPid = ({ patientOid }: { patientOid: string }) => {
  return useQuery(
    getPatientByPidQueryKeys({
      patientOid,
    }),
    () =>
      getPatientByPid({
        patientOid: patientOid,
      }),
    {
      enabled: !!patientOid,
      staleTime: 1000 * 60 * 5,
    }
  );
};

export default useGetPatientByPid;

export function getPatientByPidQueryKeys({
  patientOid,
}: {
  patientOid?: string;
}) {
  const key = [`get-patient-by-pid`];

  if (patientOid) {
    key.push(patientOid);
  }
  return key;
}
